function handleResourceDownload(e, dropdown) {
  e.preventDefault();

  const form = e.target.closest('form.resource-form');
  const dropdownToggle = dropdown.querySelector('.dropdown-toggle');
  const checkedResources = form.querySelectorAll('input:checked');

  checkedResources.forEach((resource) => {
    window.open(resource.value);
    // eslint-disable-next-line no-param-reassign
    resource.checked = false;
  });

  dropdownToggle.click();
}

function toggleLockedResourceWarning(e) {
  const form = e.target.closest('form.resource-form');
  const warningMsg = form.querySelector('.locked-resource-warning');

  if (e.target.checked) {
    warningMsg.style.display = 'flex';
  } else {
    warningMsg.style.display = 'none';
  }
}

export function initializeResourceDropdown() {
  const resourcesDropdowns = Array.from(
    document.querySelectorAll('.resources-dropdown')
  );
  resourcesDropdowns.forEach((resourceDropdown) => {
    const submitButton = resourceDropdown.querySelector(
      '.resource-form-submit'
    );
    submitButton.addEventListener('click', (e) =>
      handleResourceDownload(e, resourceDropdown)
    );

    const lockedResources =
      resourceDropdown.querySelectorAll('.resource-locked');
    lockedResources.forEach((lockedResource) =>
      lockedResource.addEventListener('change', (e) =>
        toggleLockedResourceWarning(e)
      )
    );
  });
}
